export default "__VITE_ASSET__BCWLyCjb__"